module.exports = __webpack_public_path__ + "img/head-details-banner.b85afe74.jpg";